module.exports = __webpack_public_path__ + "img/img_ghost_15@3x.5ab13de9.png";